/* eslint-disable import/no-unresolved */
import React from "react"
import styled from "styled-components"
import container from "container/BrokerDashboard/globalPagesContainer"
import { Button, Tooltip } from "antd"
import ViewListings from "../ViewListings/index"

const HeaderWrap = styled.div`
  display: flex;
  margin-top: 40px;
  > div {
    &:nth-child(1) {
      flex: 1;
    }
    &:nth-child(2) {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`

const TCListingsView = ({ goToEditListings, form, getContractsDetailsResponse }) => {
  const firstDeal = form[0]
  const isReferral = firstDeal?.client_type === "referral"
  const isListingLocked = firstDeal?.listing_status === "pending"
  const editListingsDisabled = isListingLocked || isReferral
  const editListingsTooltip = isReferral
    ? "Listings cannot be edited for referral deals"
    : isListingLocked
      ? "Can only change once in Listing"
      : "Click To Edit this Listing"

  return (
    <>
      <HeaderWrap>
        <div>
          <h3>
            TC Listing Details
          </h3>
        </div>
        <div>
          <Tooltip
            placement="left"
            title={editListingsTooltip}
            color="cyan"
          >
            <Button
              type="primary"
              onClick={() => goToEditListings()}
              disabled={editListingsDisabled}
              style={{
                marginTop: 13,
                marginLeft: 10,
              }}
            >
              Edit Listings
            </Button>
          </Tooltip>
        </div>
      </HeaderWrap>
      <ViewListings couponClaimed={getContractsDetailsResponse?.data} />
    </>
  )
}

export default container(TCListingsView)
